import {
  faChevronLeft,
  faChevronRight,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import React from "react";
import { patientPhotoUrl } from "../config/practice";

export const HistoryModal = ({ isOpen, selectedpatient, historyData, onClose }) => {
 
const data=selectedpatient||{}
  const payments = historyData || [];
const [page, setPage] = React.useState(1);
const pageSize = 5;
 if (!isOpen) return null;
const start = (page - 1) * pageSize;
const end = start + pageSize;

const paginatedPayments = payments.slice(start, end);

const totalPages = Math.ceil(payments.length / pageSize);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div
        className="bg-white rounded-xl shadow-lg w-[900px] max-w-[90%] relative animate-fadeIn flex flex-col"
        style={{
          height: "80vh",
        }}
      >
        {/* Header */}
        <div className="flex justify-between bg-[rgba(80, 134, 154, 0.10)] border-bottom-[#E5E7EB] items-start p-3 border-b"
        style={{background:"rgba(80, 134, 154, 0.10)"}}>
          <h2 className="text-xl font-inter font-semibold text-[#000000]">
            Payment History
          </h2>
          <button onClick={onClose} className="focus:outline-none">
            <FontAwesomeIcon
              icon={faXmark}
              className="text-[#000000] text-[18px]"
            />
          </button>
        </div>
<div className="p-4">

 <div className="flex justify-center  items-center">
              <div className="w-[110px] flex items-start flex-col ">
                <div
                 
                  className="relative flex cursor-pointer justify-center items-center"
                >
                  <img
                    src={patientPhotoUrl(data.patientid)}
                    alt="profile"
                    onError={(e) =>
                      (e.target.src =
                        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")
                    }
                    className="flex justify-center items-center w-[70px] h-[70px]  border-2 border-[pink] rounded-[14px]  "
                 
                  />
                </div>
              </div>
              <div className="w-full flex justify-start flex-col items-start gap-[2px]">
                <div className="text-[#0F172B] font-[500] text-[18px] font-inter">
                  {data?.patient_name|| "-"}
                </div>

                <div className=" flex gap-1 items-center">
                  <div className="text-[#62748E] font-inter font-normal text-sm tracking-wide">
                    #{data?.patientid || "-"}
                  </div>
                </div>
      
                <div className="flex flex-col justify-between ">
                  <p className="text-sm font-inter font-normal text-[#62748E] my-0">
                    DOB : {dayjs(data?.dob).format("MM/DD/YYYY") || "-"}
                  </p>
                </div>
              </div>
            </div>

</div>
        {/* Scrollable Table */}
        <div className="flex-1 overflow-y-auto ">
          <table className="min-w-full border-collapse">
            <thead className="bg-[#F9FAFB] sticky top-0">
              <tr>
                <th className="font-inter text-[#6A7282] py-3 px-4 text-left font-medium text-xs">
                  DATE
                </th>
                <th className="font-inter text-[#6A7282] py-3 px-4 text-left font-medium text-xs">
                  TIME
                </th>
                <th className="font-inter text-[#6A7282] py-3 px-4 text-left font-medium text-xs">
                  LOCATION
                </th>
                <th className="font-inter text-[#6A7282] py-3 px-4 text-left font-medium text-xs">
                  STATUS
                </th>
                <th className="font-inter text-[#6A7282] py-3 px-4 text-left font-medium text-xs">
                  AMOUNT
                </th>
                <th className="font-inter text-[#6A7282] py-3 px-4 text-center font-medium text-xs">
                  PAYMENT METHOD
                </th>
              </tr>
            </thead>
            <tbody>
          {paginatedPayments.length === 0 && (
                <tr>
                  <td colSpan={6} className="text-center py-4 text-gray-500">
                    No payment history available
                  </td>
                </tr>
              )}
           {paginatedPayments.map((p, i) => (
                <tr key={i} className="border-b last:border-0 hover:bg-gray-50">
                  <td className="py-3 px-4 text-sm text-[#101828] font-inter text-left">
                    {p.created_on || p.date}
                  </td>
                  <td className="py-3 px-4 text-sm text-[#101828] font-inter text-left">
                    {p.created_at || p.time}
                  </td>
                  <td className="py-3 px-4 text-sm text-[#101828] font-inter text-left">
                    {p.payment_location || p.location}
                  </td>
                  <td className="py-3 px-4 text-sm text-[#101828] font-inter text-left">
                    <span
  className={`px-2 py-1 rounded-full text-xs font-semibold ${
    (p.payment_status || p.status)?.toLowerCase() === "success"
      ? "bg-[#DCFCE7] text-[#016630]"
      : "bg-[#FEE4E2] text-[#B42318]"
  }`}
>
  {(p.payment_status || p.status)?.toLowerCase()}
</span>
                  </td>
                  <td className="py-3 px-4 text-sm text-[#101828] font-inter text-left">
                    {p.amount ? `$${p.amount}` : p.amount}
                  </td>
                  <td className="py-3 px-4 text-sm text-[#101828] font-inter text-center">
                    {p.method || p.payment_method}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="flex justify-between items-center p-2.5 bg-[#F9FAFB] border-t rounded-b-xl">
          <span className="text-[#6A7282] text-sm font-inter font-normal">
            Showing {payments.length} of {payments.length} records
          </span>
         <div className="flex gap-2">
  <button
    disabled={page === 1}
    onClick={() => setPage(page - 1)}
    className={`px-3 py-1 border rounded-md text-sm font-inter flex items-center gap-1 
      ${page === 1 ? "bg-gray-200 text-gray-400 cursor-not-allowed" : "bg-[#E5E7EB] text-[#364153] hover:bg-gray-100"}
    `}
  >
    <FontAwesomeIcon icon={faChevronLeft} className="text-[12px]" />
    Previous
  </button>

  <button
    disabled={page === totalPages}
    onClick={() => setPage(page + 1)}
    className={`px-3 py-1 rounded-md text-sm font-inter flex items-center gap-1 
      ${page === totalPages ? "bg-gray-300 text-gray-400 cursor-not-allowed" : "bg-black text-white hover:bg-gray-800"}
    `}
  >
    Next
    <FontAwesomeIcon icon={faChevronRight} className="text-[12px]" />
  </button>
</div>

        </div>
      </div>
    </div>
  );
};
